import { TypographyProps, useTheme } from '@mui/material';
import { memo } from 'react';
import { Trans } from 'react-i18next';

import { Hyperlink } from '@/components/Form/Form.styled';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs/selectors';

import { PolicyFooterContent } from './PolicyFooter.styled';

type PolicyFooterProps = {
  countryCode: string;
} & TypographyProps;

export const PolicyFooter = memo(function ({
  countryCode,
  ...props
}: PolicyFooterProps) {
  const { t, country, language } = useTranslate();
  const { links } = useAppSelector(selectConfigsState);
  const theme = useTheme();
  return (
    <PolicyFooterContent
      variant="caption"
      color={theme.palette.neutral[800]}
      {...props}
    >
      <Trans
        i18nKey="login.tocDescription"
        lang={language}
        components={{
          a1: (
            <Hyperlink href={links?.privacyPolicyURL}>
              {t('common.countryPrivacyPolicy', {
                country:
                  country[countryCode === 'VGB' ? 'VGB-shorten' : countryCode],
              })}
            </Hyperlink>
          ),
          a2: (
            <Hyperlink href={links?.termsAndConditionsURL}>
              {t('common.countryTermsAndConditions', {
                country:
                  country[countryCode === 'VGB' ? 'VGB-shorten' : countryCode],
              })}
            </Hyperlink>
          ),
          a3: (
            <Hyperlink href={links?.biometricConsentURL}>
              <Trans
                i18nKey="common.biometricConsent"
                lang={language}
                components={{ i: <i /> }}
              />
            </Hyperlink>
          ),
          a4: (
            <Hyperlink href={links?.termsOfUseURL}>
              <Trans
                i18nKey="common.roTermOfUse"
                lang={language}
                components={{ i: <i /> }}
              />
            </Hyperlink>
          ),
        }}
      />
    </PolicyFooterContent>
  );
});
